// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variáveis de layout */
:host {
  --header-height: 60px;
  --sidenav-width-expanded: 240px;
  --sidenav-width-collapsed: 60px;
  --breadcrumb-height: 30px;
}

.app {
  display: flex;
  top: var(--dev-banner-height);
  margin: 0px;
  padding: 0px;
  width: 100dvw;
  height: calc(100dvh - var(--dev-banner-height));
  background-color: var(--app-legacy-canvas);
  overflow: scroll;
  overscroll-behavior-y: none;
}

app-header {
  position: fixed;
  top: var(--dev-banner-height);
  left: 0px;
  width: 100%;
  height: var(--header-height, 60px);
  padding: 5px;
  z-index: 4;
  box-shadow: 0px 0px 6px 0px var(--app-ink-alpha-500);
  background-color: var(--app-legacy-canvas);
  transition:
    left 250ms ease-in-out,
    width 250ms ease-in-out;
}
app-breadcrumb {
  position: sticky;
  top: calc(-1 * var(--breadcrumb-height, 30px) - 8px);
  flex-shrink: 0;
  z-index: 2;
  width: 100%;
  height: var(--breadcrumb-height, 30px);
  padding: 10px;
  color: var(--app-legacy-menu-card-text);
  background-color: var(--app-legacy-canvas);
  border-bottom: solid 0.75px var(--app-legacy-border);
  transition: top 0.5s ease-in-out;
}
app-breadcrumb.is-recalled {
  top: 0;
}
@media (prefers-reduced-motion: reduce) {
  app-breadcrumb {
    transition: none;
  }
}
app-sidenav {
  position: absolute;
  z-index: 3;
  top: var(--dev-banner-height);
  left: 0px;
  width: var(--sidenav-width-expanded, 240px);
  height: calc(100dvh - var(--dev-banner-height));
  background-color: var(--app-white);
  overflow-x: hidden;
  white-space: nowrap;
  transition:
    left 250ms ease-in-out,
    width 250ms ease-in-out,
    box-shadow 250ms ease-in-out;
}
app-sidenav.closed {
  width: var(--sidenav-width-collapsed, 60px);
}
main {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--app-legacy-canvas);
  top: calc(var(--dev-banner-height) + var(--header-height, 60px));
  left: var(--sidenav-width-expanded, 240px);
  width: calc(100% - var(--sidenav-width-expanded, 240px));
  height: calc(100dvh - var(--dev-banner-height) - var(--header-height, 60px));
  scroll-padding-top: var(--breadcrumb-height, 30px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: none;
  scrollbar-width: thin;
  scrollbar-color: var(--app-ink-alpha-250) transparent;
  transition:
    top 250ms ease-in-out,
    left 250ms ease-in-out,
    width 250ms ease-in-out,
    height 250ms ease-in-out;
}
main.expanded {
  left: var(--sidenav-width-collapsed, 60px);
  width: calc(100% - var(--sidenav-width-collapsed, 60px));
}

main .main-content {
  padding: 0rem 1rem 2rem !important;
}

/* TABLET (641-1024px) */
@media (min-width: 641px) and (max-width: 1024px) {
  .sidenav-overlay {
    opacity: 0;
    pointer-events: none;
    transition: opacity 300ms ease-in-out;
  }

  .sidenav-overlay.show {
    position: fixed;
    z-index: 2;
    display: block !important;
    top: var(--header-height, 60px);
    left: 0px;
    width: 100dvw;
    height: calc(100dvh - var(--header-height, 60px));
    background: var(--app-black);
    opacity: 0.25;
    pointer-events: auto;
    transition: opacity 300ms ease-in-out;
  }

  app-sidenav {
    width: var(--sidenav-width-collapsed, 60px);
  }

  app-sidenav:not(.closed) {
    width: var(--sidenav-width-expanded, 240px);
    box-shadow:
      0 4px 6px -1px var(--app-ink-alpha-100),
      0 2px 4px -1px var(--app-ink-alpha-60);
  }
}

/* MOBILE (≤640px) */
@media (max-width: 640px) {
  .sidenav-overlay {
    opacity: 0;
    pointer-events: none;
    transition: opacity 300ms ease-in-out;
  }

  .sidenav-overlay.show {
    position: fixed;
    z-index: 3;
    display: block !important;
    top: 0px;
    left: 0px;
    width: 100dvw;
    height: 100dvh;
    background: var(--app-black);
    opacity: 0.25;
    pointer-events: auto;
    transition: opacity 300ms ease-in-out;
  }

  main,
  main.expanded {
    left: 0px;
    width: 100%;
    z-index: 1;
  }
  main .main-content {
    padding: 0rem 0.5rem 2rem !important;
  }
  app-breadcrumb {
    z-index: 3;
  }
  app-header,
  app-header.expanded {
    left: 0px;
    padding-left: 0px;
    z-index: 5;
    box-shadow: 0px 0px 6px var(--app-ink-alpha-500);
  }
  app-sidenav {
    top: var(--dev-banner-height);
    left: 0px;
    height: calc(100dvh - var(--dev-banner-height));
    border-radius: 0px;
    z-index: 4;
  }
  app-sidenav.closed {
    left: calc(-1 * var(--sidenav-width-collapsed, 60px));
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/main/main.component.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,UAAU;EACV,oDAAoD;EACpD,0CAA0C;EAC1C;;2BAEyB;AAC3B;AACA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,cAAc;EACd,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,uCAAuC;EACvC,0CAA0C;EAC1C,oDAAoD;EACpD,gCAAgC;AAClC;AACA;EACE,MAAM;AACR;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,2CAA2C;EAC3C,+CAA+C;EAC/C,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB;;;gCAG8B;AAChC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gEAAgE;EAChE,0CAA0C;EAC1C,wDAAwD;EACxD,4EAA4E;EAC5E,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,qDAAqD;EACrD;;;;4BAI0B;AAC5B;AACA;EACE,0CAA0C;EAC1C,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,+BAA+B;IAC/B,SAAS;IACT,aAAa;IACb,iDAAiD;IACjD,4BAA4B;IAC5B,aAAa;IACb,oBAAoB;IACpB,qCAAqC;EACvC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,2CAA2C;IAC3C;;4CAEwC;EAC1C;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,cAAc;IACd,4BAA4B;IAC5B,aAAa;IACb,oBAAoB;IACpB,qCAAqC;EACvC;;EAEA;;IAEE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;EACA;IACE,oCAAoC;EACtC;EACA;IACE,UAAU;EACZ;EACA;;IAEE,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,gDAAgD;EAClD;EACA;IACE,6BAA6B;IAC7B,SAAS;IACT,+CAA+C;IAC/C,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,qDAAqD;IACrD,gBAAgB;EAClB;AACF","sourcesContent":["/* Variáveis de layout */\n:host {\n  --header-height: 60px;\n  --sidenav-width-expanded: 240px;\n  --sidenav-width-collapsed: 60px;\n  --breadcrumb-height: 30px;\n}\n\n.app {\n  display: flex;\n  top: var(--dev-banner-height);\n  margin: 0px;\n  padding: 0px;\n  width: 100dvw;\n  height: calc(100dvh - var(--dev-banner-height));\n  background-color: var(--app-legacy-canvas);\n  overflow: scroll;\n  overscroll-behavior-y: none;\n}\n\napp-header {\n  position: fixed;\n  top: var(--dev-banner-height);\n  left: 0px;\n  width: 100%;\n  height: var(--header-height, 60px);\n  padding: 5px;\n  z-index: 4;\n  box-shadow: 0px 0px 6px 0px var(--app-ink-alpha-500);\n  background-color: var(--app-legacy-canvas);\n  transition:\n    left 250ms ease-in-out,\n    width 250ms ease-in-out;\n}\napp-breadcrumb {\n  position: sticky;\n  top: calc(-1 * var(--breadcrumb-height, 30px) - 8px);\n  flex-shrink: 0;\n  z-index: 2;\n  width: 100%;\n  height: var(--breadcrumb-height, 30px);\n  padding: 10px;\n  color: var(--app-legacy-menu-card-text);\n  background-color: var(--app-legacy-canvas);\n  border-bottom: solid 0.75px var(--app-legacy-border);\n  transition: top 0.5s ease-in-out;\n}\napp-breadcrumb.is-recalled {\n  top: 0;\n}\n@media (prefers-reduced-motion: reduce) {\n  app-breadcrumb {\n    transition: none;\n  }\n}\napp-sidenav {\n  position: absolute;\n  z-index: 3;\n  top: var(--dev-banner-height);\n  left: 0px;\n  width: var(--sidenav-width-expanded, 240px);\n  height: calc(100dvh - var(--dev-banner-height));\n  background-color: var(--app-white);\n  overflow-x: hidden;\n  white-space: nowrap;\n  transition:\n    left 250ms ease-in-out,\n    width 250ms ease-in-out,\n    box-shadow 250ms ease-in-out;\n}\napp-sidenav.closed {\n  width: var(--sidenav-width-collapsed, 60px);\n}\nmain {\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--app-legacy-canvas);\n  top: calc(var(--dev-banner-height) + var(--header-height, 60px));\n  left: var(--sidenav-width-expanded, 240px);\n  width: calc(100% - var(--sidenav-width-expanded, 240px));\n  height: calc(100dvh - var(--dev-banner-height) - var(--header-height, 60px));\n  scroll-padding-top: var(--breadcrumb-height, 30px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior-y: none;\n  scrollbar-width: thin;\n  scrollbar-color: var(--app-ink-alpha-250) transparent;\n  transition:\n    top 250ms ease-in-out,\n    left 250ms ease-in-out,\n    width 250ms ease-in-out,\n    height 250ms ease-in-out;\n}\nmain.expanded {\n  left: var(--sidenav-width-collapsed, 60px);\n  width: calc(100% - var(--sidenav-width-collapsed, 60px));\n}\n\nmain .main-content {\n  padding: 0rem 1rem 2rem !important;\n}\n\n/* TABLET (641-1024px) */\n@media (min-width: 641px) and (max-width: 1024px) {\n  .sidenav-overlay {\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 300ms ease-in-out;\n  }\n\n  .sidenav-overlay.show {\n    position: fixed;\n    z-index: 2;\n    display: block !important;\n    top: var(--header-height, 60px);\n    left: 0px;\n    width: 100dvw;\n    height: calc(100dvh - var(--header-height, 60px));\n    background: var(--app-black);\n    opacity: 0.25;\n    pointer-events: auto;\n    transition: opacity 300ms ease-in-out;\n  }\n\n  app-sidenav {\n    width: var(--sidenav-width-collapsed, 60px);\n  }\n\n  app-sidenav:not(.closed) {\n    width: var(--sidenav-width-expanded, 240px);\n    box-shadow:\n      0 4px 6px -1px var(--app-ink-alpha-100),\n      0 2px 4px -1px var(--app-ink-alpha-60);\n  }\n}\n\n/* MOBILE (≤640px) */\n@media (max-width: 640px) {\n  .sidenav-overlay {\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 300ms ease-in-out;\n  }\n\n  .sidenav-overlay.show {\n    position: fixed;\n    z-index: 3;\n    display: block !important;\n    top: 0px;\n    left: 0px;\n    width: 100dvw;\n    height: 100dvh;\n    background: var(--app-black);\n    opacity: 0.25;\n    pointer-events: auto;\n    transition: opacity 300ms ease-in-out;\n  }\n\n  main,\n  main.expanded {\n    left: 0px;\n    width: 100%;\n    z-index: 1;\n  }\n  main .main-content {\n    padding: 0rem 0.5rem 2rem !important;\n  }\n  app-breadcrumb {\n    z-index: 3;\n  }\n  app-header,\n  app-header.expanded {\n    left: 0px;\n    padding-left: 0px;\n    z-index: 5;\n    box-shadow: 0px 0px 6px var(--app-ink-alpha-500);\n  }\n  app-sidenav {\n    top: var(--dev-banner-height);\n    left: 0px;\n    height: calc(100dvh - var(--dev-banner-height));\n    border-radius: 0px;\n    z-index: 4;\n  }\n  app-sidenav.closed {\n    left: calc(-1 * var(--sidenav-width-collapsed, 60px));\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
